import { render, staticRenderFns } from "./ricePic.vue?vue&type=template&id=400e4780&scoped=true&"
import script from "./ricePic.vue?vue&type=script&lang=js&"
export * from "./ricePic.vue?vue&type=script&lang=js&"
import style0 from "./ricePic.vue?vue&type=style&index=0&id=400e4780&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400e4780",
  null
  
)

export default component.exports